import { css } from "@emotion/css";
import { Text } from "../../../components/common";
import React from "react";

type Props = {
  title: string;
  active?: boolean;
  onClick?: () => void;
};

export const TabItems: React.FC<Props> = ({ title, active, onClick }) => {
  return (
    <div
      className={css`
        min-width: 155px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 57px;
        border: 1px solid #2e2d33;
        position: relative;
        margin-right: 10px;
        cursor: pointer;
        overflow: hidden;
      `}
      onClick={onClick}
    >
      <Text.Body2XS
        style={{
          fontSize: "12px",
          color: active ? "#fff" : "#2E2D33",
        }}
      >
        {title}
      </Text.Body2XS>

      {active && (
        <div
          className={css`
            position: absolute;
            bottom: -10px;
            right: 0;
          `}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="142"
            height="41"
            viewBox="0 0 142 41"
            fill="none"
          >
            <g filter="url(#filter0_f_6815_1123)">
              <ellipse
                cx="117"
                cy="70.0547"
                rx="73"
                ry="57"
                fill="#313131"
                fillOpacity="0.5"
              />
            </g>
            <defs>
              <filter
                id="filter0_f_6815_1123"
                x="0"
                y="-30.9453"
                width="234"
                height="202"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="22"
                  result="effect1_foregroundBlur_6815_1123"
                />
              </filter>
            </defs>
          </svg>
        </div>
      )}
    </div>
  );
};
